import {
  settinAdConfigSteps,
  settingDimensionSteps,
  settingEmailConfigSteps,
  settingEmailTempSteps,
  settingOtherSteps,
  settingUserCreationSteps,
} from "./Settings.tsx";

const pathToStepsMap = {
  userflow: settingUserCreationSteps,
  dimensions: settingDimensionSteps,
  ad: settinAdConfigSteps,
  email: settingEmailConfigSteps,
  emailtemplates: settingEmailTempSteps,
  other: settingOtherSteps,
};

export const getSettingJoyrideSteps = (path) => {
   const tabKey = path?.split("/")?.pop();

 if (tabKey === "settings" || !tabKey) {
    return settingUserCreationSteps;
  }

  return pathToStepsMap[tabKey] || [];
};